<div *ngIf="selecionado">
  <app-passagens-cadastro
    [model]="selecionado"
    (buscar)="buscar($event)"
    [state]="state">
  </app-passagens-cadastro>
</div>
<div *ngIf="!selecionado">
  <app-passagens-filtro [filtros]="filtros"></app-passagens-filtro>
  <app-passagens-lista
    [filtros]="filtros"
    (exibir)="selecionar($event)"
    (definirFiltro)="definirFiltro()">
  </app-passagens-lista>
</div>